import { PreboardingFormWizard } from '@/features/preboarding-forms/wizard/preboarding-form-wizard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/preboarding-forms/$id')({
  component: PreboardingFormEditorPage,
});

function PreboardingFormEditorPage() {
  const { id } = Route.useParams();
  return <PreboardingFormWizard formId={id} />;
}
